import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Grid,
  styled,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Paper,
  Button,
  Autocomplete,
  Typography,
  Tabs,
  Tab,
  Box
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PageHeader from '../../../components/PageHeader';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { formatDate } from '../../../util';
import { api } from '../../../api';
import { Company } from '../../../schema/company';
import { Person } from '../../../schema/person';

const CreateBlacklist: React.FC = () => {
  const navigate = useNavigate();
  const [personList, setPersonList] = useState<Person[]>([]);

  const [blacklistType, setBlacklistType] = useState<'permanent' | 'temporary'>('permanent');
  const [companyList, setCompanyList] = useState<Company[]>([]);
  const [personNameSearchKeyword, setPersonNameSearchKeyword] = useState<string>('');
  const [personIdSearchKeyword, setPersonIdSearchKeyword] = useState<string>('');
  const [person, setPerson] = useState<Person | null>(null);
  const [company, setCompany] = useState<Company | null>(null);
  const [companySearchKeyword, setCompanySearchKeyword] = useState<string>('');
  const [companyIdSearchKeyword, setCompanyIdSearchKeyword] = useState<string>('');

  const [requestType, setRequestType] = useState<'person' | 'company'>('person');

  const [reason, setReason] = useState<string>('');
  const [endDate, setEndDate] = useState<Date | null>(null);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (isLoading) {
      return;
    }
    if (requestType == 'person') {
      if (person?.id) {
        setIsLoading(true);
        api
          .post<Person[]>(`/blacklist`, {
            person_id: person?.id,
            blacklist_end_date:
              blacklistType == 'permanent' ? null : endDate ? formatDate(endDate) : null,
            reason: reason
          })
          .then(() => {
            navigate('/blacklist');
          })
          .finally(() => setIsLoading(false));
      }
    } else if (requestType == 'company') {
      if (company?.id) {
        setIsLoading(true);
        api
          .post<Person[]>(`/blacklist_company`, {
            company_id: company?.id,
            blacklist_end_date:
              blacklistType == 'permanent' ? null : endDate ? formatDate(endDate) : null,
            reason: reason
          })
          .then(() => {
            navigate('/blacklist');
          })
          .finally(() => setIsLoading(false));
      }
    }
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      const searchParams = new URLSearchParams();
      if (personIdSearchKeyword) {
        searchParams.set('personnal_id', `${personIdSearchKeyword}`);
      }
      if (personNameSearchKeyword) {
        searchParams.set('name', `${personNameSearchKeyword}`);
      }
      searchParams.set('limit', `${10}`);
      api.get<Person[]>(`/person`, { params: searchParams }).then((res) => {
        const { data } = res;
        setPersonList(data);
      });
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [personNameSearchKeyword, personIdSearchKeyword]);



  useEffect(() => {
    const timeOutId = setTimeout(() => {
      const searchParams = new URLSearchParams();
      if (companySearchKeyword) {
        searchParams.set('company_name', `${companySearchKeyword}`);
      }
      if (companyIdSearchKeyword) {
        searchParams.set('company_id', `${companyIdSearchKeyword}`);
      }
      searchParams.set('limit', `${10}`);
      api.get<Company[]>(`/company`, { params: searchParams }).then((res) => {
        const { data } = res;
        setCompanyList(data);
      });
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [companySearchKeyword, companyIdSearchKeyword]);

  return (
    <Container>
      <PageHeader text="เพิ่มข้อมูล Blacklist" />
      <Button component={Link} to={`/blacklist`} sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        blacklist
      </Button>

      {/* <Typography variant="body2" sx={{ paddingY: 3 }}>
        เพิ่มข้อมูลการขอแลกบัตรล่วงเวลา
      </Typography> */}
      <Paper>
        <Typography variant="h6" sx={{ px: 2, pt: 2, pb: 1 }}>
          เพิ่มข้อมูล
        </Typography>
        <Box sx={{ px: 2 }}>
          <Tabs
            onChange={(_, value) => {
              {
                setRequestType(value == 'company' ? 'company' : 'person');
                setCompanySearchKeyword('');
                setPersonNameSearchKeyword('');
                setCompany(null);
                setPerson(null);
              }
            }}
            value={requestType}
          >
            <Tab value="person" label="บุคคล" />
            <Tab value="company" label="บริษัท" />
          </Tabs>
        </Box>

        <Form onSubmit={handleFormSubmit} sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            {/* <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="contractor-type">ประเภทการร้องขอ</InputLabel>
                <Select
                  labelId="request-type"
                  label="ประเภทการร้องขอ"
                  name="requestType"
                  variant="outlined"
                  onChange={(e) => {
                    {
                      setRequestType(e.target.value == 'company' ? 'company' : 'person');
                      setCompanySearchKeyword('');
                      setPersonNameSearchKeyword('');
                      setCompany(null);
                      setPerson(null);
                    }
                  }}
                  value={requestType}
                  autoComplete="off"
                >
                  <MenuItem value="person">บุคคล</MenuItem>
                  <MenuItem value="company">บริษัท</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}></Grid> */}
            {requestType == 'person' ? (
              <>
                <Grid item xs={6}>
                  <Autocomplete
                    disablePortal
                    options={personList}
                    getOptionLabel={(option) => (option?.personnal_id ? option.personnal_id : '')}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" label="ค้นหาจากเลขบัตร" required />
                    )}
                    onChange={(_, value) => setPerson(value ? value : null)}
                    value={person}
                    onInputChange={(_, newInputValue) => {
                      setPersonIdSearchKeyword(newInputValue);
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    disablePortal
                    // value={person}
                    options={personList}
                    getOptionLabel={(option) => (option?.full_name ? option.full_name : '')}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" label="ชื่อ - นามสกุล" required />
                    )}
                    onChange={(_, value) => setPerson(value ? value : null)}
                    value={person}
                    onInputChange={(_, newInputValue) => {
                      setPersonNameSearchKeyword(newInputValue);
                    }}
                  />

                  
                </Grid>
                {person ? (
                  <>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="บริษัท"
                        variant="outlined"
                        placeholder="บริษัท"
                        InputProps={{ readOnly: true }}
                        value={person?.company?.company_name ? person.company.company_name : ''}
                        disabled={!person?.company?.company_name}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="ประเภทบุคคล"
                        variant="outlined"
                        placeholder="ประเภทบุคคล"
                        InputProps={{ readOnly: true }}
                        value={person?.person_type?.type_name ? person.person_type.type_name : ''}
                        disabled={!person?.person_type?.type_name}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="เบอร์โทรศัพท์"
                        variant="outlined"
                        placeholder="เบอร์โทรศัพท์"
                        InputProps={{ readOnly: true }}
                        value={person?.phone_number ? person.phone_number : ''}
                        disabled={!person?.phone_number}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="อีเมล"
                        variant="outlined"
                        placeholder="อีเมล"
                        InputProps={{ readOnly: true }}
                        value={person?.email ? person.email : ''}
                        disabled={!person?.email}
                      />
                    </Grid>
                    {/* <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="ชื่อผู้คุมงาน"
                        variant="outlined"
                        placeholder="ชื่อผู้คุมงาน"
                        InputProps={{ readOnly: true }}
                        value={person?.supervisor?.full_name ? person.supervisor.full_name : ''}
                        disabled={!person?.supervisor?.full_name}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="หน่วยงาน"
                        variant="outlined"
                        placeholder="หน่วยงาน"
                        InputProps={{ readOnly: true }}
                        value={
                          person?.supervisor?.department?.department_name
                            ? person.supervisor.department.department_name
                            : ''
                        }
                        disabled={!person?.supervisor?.department?.department_name}
                      />
                    </Grid> */}
                  </>
                ) : null}
              </>
            ) : (
              <>
                <Grid item xs={6}>
                  <Autocomplete
                    disablePortal
                    id="name"
                    options={companyList}
                    getOptionLabel={(option) => (option?.company_id ? option.company_id : '')}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="เลขที่ผู้เสียภาษี"
                        required
                      />
                    )}
                    onChange={(_, value) => setCompany(value ? value : null)}
                    value={company}
                    onInputChange={(_, newInputValue) => {
                      setCompanyIdSearchKeyword(newInputValue);
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    id="company"
                    disablePortal
                    options={companyList}
                    getOptionLabel={(option) => (option?.company_name ? option.company_name : '')}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" label="ชื่อบริษัท" required />
                    )}
                    onChange={(_, value) => setCompany(value ? value : null)}
                    value={company}
                    onInputChange={(_, newInputValue) => {
                      setCompanySearchKeyword(newInputValue);
                    }}
                  />
                </Grid>
                {company ? (
                  <>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="รหัสบริษัท"
                        variant="outlined"
                        placeholder="รหัสบริษัท"
                        InputProps={{ readOnly: true }}
                        value={company?.company_code ? company.company_code : ''}
                        disabled={!company?.company_code}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="อีเมล"
                        variant="outlined"
                        placeholder="อีเมล"
                        InputProps={{ readOnly: true }}
                        value={company?.email ? company.email : ''}
                        disabled={!company?.email}
                      />
                    </Grid>
                  </>
                ) : null}
              </>
            )}
          </Grid>

          <Grid container spacing={2} mt={4}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel id="contractor-type">ประเภท Blacklist</InputLabel>
                  <Select
                    labelId="request-type"
                    label="ประเภทการร้องขอ"
                    name="requestType"
                    variant="outlined"
                    onChange={(e) => {
                      setBlacklistType(e.target.value == 'temporary' ? 'temporary' : 'permanent');
                    }}
                    value={blacklistType}
                    autoComplete="off"
                  >
                    <MenuItem value="permanent">ถาวร</MenuItem>
                    <MenuItem value="temporary">ชั่วคราว</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <DesktopDatePicker
                  label="วันที่สิ้นสุด Blacklist"
                  inputFormat="MM/dd/yyyy"
                  value={endDate}
                  onChange={(value) => setEndDate(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      disabled={blacklistType == 'permanent'}
                      required={blacklistType == 'temporary'}
                    />
                  )}
                  disabled={blacklistType == 'permanent'}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="สาเหตุ"
                  variant="outlined"
                  placeholder="สาเหตุ"
                  value={reason}
                  minRows={2}
                  multiline
                  onChange={(event) => setReason(event.target.value)}
                />
              </Grid>
            </LocalizationProvider>
          </Grid>

          <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 4 }}>
            เพิ่มข้อมูล
          </Button>
        </Form>
      </Paper>
    </Container>
  );
};

export default CreateBlacklist;

const Container = styled('div')`
  padding: 16px;
`;

const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
